import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApproval } from '../context/ApprovalContext';
import { FilePlus, Clock, CheckCircle, XCircle, AlertCircle } from 'lucide-react';

export default function Dashboard() {
  const { user } = useAuth();
  const { approvals, fetchApprovals, getPendingForMe, getMyApprovals } = useApproval();
  const navigate = useNavigate();

  useEffect(() => { fetchApprovals(); }, [fetchApprovals]);

  const myApprovals = getMyApprovals(user.id);
  const pendingForMe = getPendingForMe(user.id);
  const approved = myApprovals.filter(a => a.status === 'approved').length;
  const rejected = myApprovals.filter(a => a.status === 'rejected').length;
  const statusLabel = { pending:'대기중', approved:'승인', rejected:'반려', draft:'임시저장' };
  const recentAll = approvals.slice(0, 5);

  return (
    <div className="page container">
      <div className="page-header">
        <h1 className="page-title">안녕하세요, {user.name}님 👋</h1>
        <p className="page-subtitle">{user.dept} · {user.position}</p>
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon stat-icon-blue"><Clock size={22} color="#4f46e5" /></div>
          <div><div className="stat-num">{myApprovals.filter(a=>a.status==='pending').length}</div><div className="stat-label">진행 중인 결재</div></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon stat-icon-yellow"><AlertCircle size={22} color="#d97706" /></div>
          <div><div className="stat-num">{pendingForMe.length}</div><div className="stat-label">내가 처리할 결재</div></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon stat-icon-green"><CheckCircle size={22} color="#059669" /></div>
          <div><div className="stat-num">{approved}</div><div className="stat-label">승인 완료</div></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon stat-icon-red"><XCircle size={22} color="#dc2626" /></div>
          <div><div className="stat-num">{rejected}</div><div className="stat-label">반려된 결재</div></div>
        </div>
      </div>
      <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:20}}>
        <div className="card">
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
            <h2 style={{fontSize:16, fontWeight:600}}>⚡ 처리 대기</h2>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/list')}>전체보기</button>
          </div>
          {pendingForMe.length === 0
            ? <p style={{color:'#9ca3af', fontSize:14, textAlign:'center', padding:'20px 0'}}>처리할 결재가 없습니다</p>
            : pendingForMe.map(a => (
              <div key={a.id} onClick={() => navigate(`/detail/${a.id}`)}
                style={{padding:'12px 0', borderBottom:'1px solid #f3f4f6', cursor:'pointer'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <span style={{fontSize:14, fontWeight:500}}>{a.title}</span>
                  <span className={`badge badge-${a.status}`}>{statusLabel[a.status]}</span>
                </div>
                <p style={{fontSize:12, color:'#9ca3af', marginTop:4}}>{a.author.name} · {a.createdAt}</p>
              </div>
            ))
          }
        </div>
        <div className="card">
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
            <h2 style={{fontSize:16, fontWeight:600}}>📋 최근 결재</h2>
            <button className="btn btn-primary btn-sm" onClick={() => navigate('/new')}>
              <FilePlus size={14} /> 새 결재
            </button>
          </div>
          {recentAll.length === 0
            ? <p style={{color:'#9ca3af', fontSize:14, textAlign:'center', padding:'20px 0'}}>결재 내역이 없습니다</p>
            : recentAll.map(a => (
              <div key={a.id} onClick={() => navigate(`/detail/${a.id}`)}
                style={{padding:'12px 0', borderBottom:'1px solid #f3f4f6', cursor:'pointer'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                  <span style={{fontSize:14, fontWeight:500}}>{a.title}</span>
                  <span className={`badge badge-${a.status}`}>{statusLabel[a.status]}</span>
                </div>
                <p style={{fontSize:12, color:'#9ca3af', marginTop:4}}>{a.author.name} · {a.createdAt}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}
